import styled from "styled-components";

const MainWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 554px;
  position: ${({ position }) => position || "relative"};
`;

const UploaderWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  left: 0;
  right: 0;
  transition: all 0.2s;
  opacity: 0;
`;

const TemplateWrapper = styled.div`
  width: ${(props) => props.width}px;
  min-height: ${(props) => props.minHeight}px;
  max-height: ${(props) => props.maxHeight}px;
  height: ${(props) => props.height}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CreativeAndUploaderWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
  z-index: 1;
  &:hover {
    ${UploaderWrapper} {
      opacity: 1;
    }
  }
`;

const TemplateEditorOpenButton = styled.button`
  border: 1px solid #e8e8eb;
  background-color: #fff;
  opacity: 0.9;
  border-radius: 100%;
  transition: all 0.2s;
  box-shadow: 0px 0px 0px 800px rgb(30 31 70 / 50%);
  cursor: pointer;
  padding: 0px 2px;
  &:hover {
    opacity: 1;
  }
`;

const UploadCloudIcon = styled.img`
  ${(props) =>
    props.small
      ? `
  height: 20px;
  width: 20px;
  margin: 4px 2px;
  `
      : `
  margin: 11px 9px;
  height: 32px;
  width: 32px;
  `}
`;

export {
  MainWrapper,
  TemplateWrapper,
  CreativeAndUploaderWrapper,
  UploaderWrapper,
  TemplateEditorOpenButton,
  UploadCloudIcon
};
